// extracted by mini-css-extract-plugin
export default {"body":"Collaborates_body__UjEIh","list":"Collaborates_list__y3jp0","fadeIn":"Collaborates_fadeIn__lPqUv","hoverLineLink":"Collaborates_hoverLineLink__wDUg5"};